import { type FC } from 'react'

import { Shimmer } from '@wartek-id/shimmer'

import FilterButtons from 'app/KinerjaShared/components/FilterButtons'
import { PREDIKAT_ORGANISASI_STATUS_LABELS } from '../constants/predikatOrganisasiStatus'

import type { TPredikatOrganisasiStatusFilter } from 'types/kinerja-pelaksanaan'

export interface FileItem {
  label: string
  value: TPredikatOrganisasiStatusFilter
}

const FILTER_LABEL: Record<TPredikatOrganisasiStatusFilter, string> = {
  ALL: 'Semua',
  NOT_SENT: PREDIKAT_ORGANISASI_STATUS_LABELS['NOT_SENT'],
  READY_TO_SEND: PREDIKAT_ORGANISASI_STATUS_LABELS['READY_TO_SEND'],
  SENT: PREDIKAT_ORGANISASI_STATUS_LABELS['SENT'],
}
type FilterItems = Array<FileItem>

interface FilterSendStateProps {
  isLoading?: boolean
  activeFilter?: TPredikatOrganisasiStatusFilter
  filterValue: Record<TPredikatOrganisasiStatusFilter, number>
  onChange?: (value: TPredikatOrganisasiStatusFilter) => void
}

const FilterSendState: FC<FilterSendStateProps> = ({
  isLoading,
  activeFilter,
  filterValue,
  onChange,
}) => {
  const filterItems: FilterItems = [
    'ALL',
    'NOT_SENT',
    'READY_TO_SEND',
    'SENT',
  ].map((value: TPredikatOrganisasiStatusFilter) => ({
    label: `${FILTER_LABEL[value]} (${filterValue[value]})`,
    value,
  })) as { label: string; value: TPredikatOrganisasiStatusFilter }[]

  return (
    <div className="px-6">
      {isLoading && (
        <div className="flex gap-4">
          {Array.from({ length: 4 })?.map((_, index) => (
            <Shimmer
              width={90 + index * 20}
              height={28}
              className="!rounded-full"
              key={index}
            />
          ))}
        </div>
      )}

      {!isLoading && (
        <FilterButtons
          items={filterItems}
          activeValue={activeFilter}
          btnSize="md"
          onChange={(value) => onChange?.(value)}
        />
      )}
    </div>
  )
}
export default FilterSendState
